/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {FormSetInfoVertical} from 'Docs/uilib/layout/form-set/Examples';
import DepreciationInfo from 'Docs/uilib/layout/form-set-row-deprication';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The FormSet component gives you both a HTML form element ", _jsx(_components.code, {
        children: "<form>"
      }), " by default and also a React provider for ", _jsx(_components.a, {
        href: "/uilib/layout/form-row",
        children: "FormRow"
      }), ". This way you can define more globally e.g. if all the rows should be displayed ", _jsx(_components.strong, {
        children: "vertically"
      }), "."]
    }), "\n", _jsx(FormSetInfoVertical, {}), "\n", _jsx(DepreciationInfo, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
